import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useCounterQuote } from '~/api';
import { toastGraphQLError } from '~/utils';
import type { QuoteTallyPriceEditInput } from '~/graphql/graphql';
import type { ItemOverride } from '~/pages/quote-response/useQuoteResponseDraft';

export type CounterSubmission = Readonly<{
  itemOverrides: ItemOverride[];
  tallyPrice: QuoteTallyPriceEditInput;
  leadTimeDays: number;
}>;

export function useSendCounter(
  quoteId: string,
  onCountered: () => void
): (submission: CounterSubmission) => Promise<void> {
  const { t } = useTranslation('rfq-view');
  const { mutateAsync: counterQuote } = useCounterQuote();

  return async (submission) => {
    try {
      await counterQuote({
        quoteId,
        input: {
          ...submission,
          sellingOrganizationFacilityId: null,
          submit: false,
        },
      });
      toast.success(t('rfq_view.quote_countered'));
      onCountered();
    } catch (error) {
      toastGraphQLError(error);
    }
  };
}
